import {
  SET_BLOCK
} from 'src/store/mutation-types'
export default {
  [SET_BLOCK] (state, block) {
    state.block = block
  }
}



// WEBPACK FOOTER //
// ./src/components/block/store/mutations.js